import React from 'react';

import DateFieldPicker from 'components/Goals/GeneralGoalForm/KpiForm/DateFieldPicker';
import Inputs from 'components/Inputs';
import Typography from 'kingpin/atoms/Typography';
import { LabelDiv } from 'screens/Boards/PerformanceBoardForm';

import IntervalPicker from '../IntervalPicker/IntervalPicker';
import RollingDateInput from './RelatedDocumentsSlideoutWizard/RollingDateInput';

/**
 * "Date filter mode" (Periods / Rolling) + query date field inputs, shared by
 * the slide-out wizards. Pair with useSlideoutDateFilterState.
 */
const SlideoutDateFilterInput = ({
  dataset,
  dateFilter,
  onDateFilterModeChanged,
  setInterval,
  setLookback,
  setDateField,
}: {
  dataset?: string;
  dateFilter: PerformanceBoardTypes.SlideOut.SlideOutDateFilter;
  onDateFilterModeChanged: (
    mode: PerformanceBoardTypes.SlideOut.SlideOutDateFilter['mode'],
  ) => void;
  setInterval: React.Dispatch<
    React.SetStateAction<PerformanceBoardTypes.SlideOut.SlideOutDateRange>
  >;
  setLookback: (next: PerformanceBoardTypes.SlideOut.RollingLookback) => void;
  setDateField: React.Dispatch<React.SetStateAction<string | undefined>>;
}) => {
  const dateFilterModeOptions: DropdownOption[] = [
    {
      label: 'Periods',
      isSelected: dateFilter.mode === 'Periods',
      onSelected: () => onDateFilterModeChanged('Periods'),
    },
    {
      label: 'Rolling',
      isSelected: dateFilter.mode === 'Rolling',
      onSelected: () => onDateFilterModeChanged('Rolling'),
    },
  ];

  return (
    <>
      <div style={{ marginBottom: 24 }}>
        <LabelDiv>
          <Typography.Body type="Label">Date filter mode</Typography.Body>
        </LabelDiv>
        <Inputs.Dropdown options={dateFilterModeOptions} />
      </div>

      {dateFilter.mode === 'Periods' ? (
        <>
          {dataset && (
            <div style={{ marginBottom: 24 }}>
              <LabelDiv>
                <Typography.Body type="Label">Date Field</Typography.Body>
              </LabelDiv>
              <DateFieldPicker
                dateField={dateFilter.dateField}
                setDateField={setDateField}
                dataTypes={[dataset]}
              />
            </div>
          )}
          <div style={{ marginBottom: 24 }}>
            <IntervalPicker
              widgetDateRange={dateFilter.interval}
              setWidgetDateRange={setInterval}
            />
          </div>
        </>
      ) : (
        <div style={{ marginBottom: 24 }}>
          <RollingDateInput
            dateFilter={dateFilter}
            setLookback={setLookback}
            dateField={dateFilter.dateField}
            setDateField={setDateField}
            dataset={dataset}
          />
        </div>
      )}
    </>
  );
};

export default SlideoutDateFilterInput;
